import type { LoyaltyModuleHealth } from '../gateway/loyaltyAdmin.gateway.js';

export type LoyaltyOperationalState = 'active' | 'global_disabled' | 'tenant_disabled';

export function resolveLoyaltyOperationalState(
  health: LoyaltyModuleHealth | undefined,
): LoyaltyOperationalState | 'loading' {
  if (health === undefined) {
    return 'loading';
  }
  if (!health.moduleEnabled) {
    return 'global_disabled';
  }
  if (!health.tenantEnabled) {
    return 'tenant_disabled';
  }
  return 'active';
}

export function isLoyaltyOperational(health: LoyaltyModuleHealth): boolean {
  return health.moduleEnabled && health.tenantEnabled;
}

export const DEFAULT_LOYALTY_TENANT_ACTIVATION = {
  earnPointsPerTenCzk: 1,
  registrationBonusPoints: 1,
  firstTransactionBonusPoints: 1,
  walletLazyCreateEnabled: true,
  moduleEnabled: true,
} as const;
